import { mapState, mapActions } from 'vuex'
import util from '@/util'
import mensagens from '@/util/mensagens'
import { BToast, BSpinner } from 'bootstrap-vue'
import PainelAcesso from '@/components/layout/painelAcesso/PainelAcesso.vue'
import mascaras from '@/util/mascaras'
import Endereco from '@/components/layout/endereco/Endereco.vue'
import constants from '@/util/constants'

export default {
  name: 'aceiteContrato',
  components: {
    'b-toast': BToast,
    'b-spinner': BSpinner,
    PainelAcesso,
    Endereco
  },
  props: {
    erros: {
      type: [Array, Object],
      required: false
    }
  },
  computed: {
    ...mapState('auth', ['regrasLogin', 'representanteLegal']),
    mascaraCep () {
      return mascaras.mascarasParaCampos.cep
    },
    desabilitarCampos () {
      return this.flagsDeControle.manipulandoDados.status || this.flagsDeControle.carregandoDados.status
    },
    errosLocal: {
      get () {
        return this.erros
      }
    }
  },
  data: () => {
    return {
      formulario: {
        endereco: {
          cep: null,
          endereco: null,
          numero: null,
          complemento: null,
          bairro: null,
          cidade: null,
          uf: null,
          pais: 'Brasil',
          ibge: null
        },
        aceite_privacidade: false,
        aceite_contrato: false
      },
      flagsDeControle: {
        manipulandoDados: {
          status: false,
          mensagem: ''
        },
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      retorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: []
      }
    }
  },
  async mounted () {
    if (this.representanteLegal) {
      const { escritorio } = await this.obterDadosUsuarioLogado()
      const dadosEmpresa = await this.obterDadosEmpresa(escritorio)
      this.preencherFormulario(dadosEmpresa)
    }
    this.atualizarListaDeErros(this.errosLocal)
  },
  methods: {
    ...mapActions('auth', ['ActionSetRegrasLogin']),

    async obterDadosEmpresa (idEmpresa) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.get(`/manager/escritorios/escritorio/${idEmpresa}`)
        const dadosResposta = resposta.data.retorno.dados
        return dadosResposta
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      } finally {
        this.definirFlagCarregandoDados(false, '')
      }
    },

    atualizarListaDeErros (listaDeErros) {
      this.retorno.listaDeErros = listaDeErros
    },

    preencherFormulario (dadosEmpresa) {
      if (util.valorEhNulo(dadosEmpresa)) return

      const { cep, endereco, numero, complemento, bairro, cidade, uf } = dadosEmpresa
      const formulario = {
        ...this.formulario,
        endereco: {
          cep,
          endereco,
          numero,
          complemento,
          bairro,
          cidade,
          uf: { code: uf, label: uf }
        }
      }
      this.formulario = formulario
    },

    async obterDadosUsuarioLogado () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.get('/manager/usuarios/usuario')
        const dadosResposta = resposta.data.retorno.dados
        return {
          escritorio: dadosResposta.empresa_id
        }
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      } finally {
        this.definirFlagCarregandoDados(false, '')
      }
    },

    tratarDadosAntesEnvio () {
      const { endereco, ...formulario } = { ...this.formulario }
      const dadosEndereco = { ...endereco }
      dadosEndereco.cep = util.apenasNumeros(endereco.cep)
      dadosEndereco.uf = endereco.uf?.code ?? null
      const payload = { ...formulario, endereco: dadosEndereco }
      return payload
    },

    async salvarDadosDeAceite () {
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
      try {
        const payload = this.tratarDadosAntesEnvio()
        const resposta = await this.axios.post('/manager/aceitar/contratos', payload)
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem
        this.retorno.listaDeErros = resposta.data.retorno.listaDeErros
        if (this.retorno.sucesso === true) {
          this.emitirEventoFinalizacao()
          return
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', this.retorno.mensagem)
        }
      } catch (e) {
        console.log(e)
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      } finally {
        this.definirFlagManipulandoDados(false, '')
      }
    },

    async obterUnidadesFederativas (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }
      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'nome': valorDigitadoParaBusca }
      }
      const resposta = await this.axios.post('/manager/unidades-federativas', parametrosRequisicao)
      const listaUnidadesFederativas = resposta.data.retorno.dados
      callbackFlagCarregamento = false
      return listaUnidadesFederativas
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    emitirEventoFinalizacao () {
      const pendenciasLogin = JSON.parse(this.regrasLogin)
      pendenciasLogin.pendenteDeAceiteDeContrato = false
      this.ActionSetRegrasLogin(JSON.stringify(pendenciasLogin))
      this.$emit('finalizandoPendencia')
    }
  }
}
